<template>
<div class="chapter">
<div class="inner_page">
<div class="ImageContainer">
<img alt="Cover" class="CoverImage" id="CoverImage" src="CoverDesign.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverPage.vue?5db807f8